<div class="app-icon">
  <svg [attr.width]="size" [style.width]="size" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
    stroke-width="2" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
    <path [attr.stroke]="color" fill="transparent" d="M3 18v-6a9 9 0 0 1 18 0v6" />
    <path [attr.stroke]="color" fill="transparent"
      d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
  </svg>
</div>
